import React, { ReactNode, useEffect } from 'react';

interface DisableImageRightClickWrapperProps {
  children: ReactNode;
}

const useDisableImageRightClickMenu = () => {
  useEffect(() => {
    const disableContextMenu = (event: MouseEvent) => {
      event.preventDefault();
    };

    const observeImages = () => {
      const images = document.querySelectorAll('img');
      images.forEach((img) => {
        img.addEventListener('contextmenu', disableContextMenu);
      });
    };

    const observer = new MutationObserver(observeImages);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    observeImages();

    return () => {
      observer.disconnect();
      const images = document.querySelectorAll('img');
      images.forEach((img) => {
        img.removeEventListener('contextmenu', disableContextMenu);
      });
    };
  }, []);
};

const DisableImageRightClickWrapper: React.FC<DisableImageRightClickWrapperProps> = ({ children }) => {
  useDisableImageRightClickMenu();

  return <>{children}</>;
};

export default DisableImageRightClickWrapper;
